require('../../../modules/es.array.map');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').map;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/map.js
// module id = 4079
// module chunks = 25